import http from '../../../Http';
import { useEffect, useState, useContext, useRef } from 'react';
import utils from '../../../utils';
import { Table, Input, Button, Modal, Dropdown, Space, Menu } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, DownOutlined, ExclamationCircleOutlined, SwitcherOutlined  } from '@ant-design/icons';
import InverterWithAgilePriceAddOrModify from './InverterWithAgilePriceAddOrModify';
import { useTranslation } from 'react-i18next';

function InverterWithAgilePriceList ({ onInverterSelect }) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [params, setParams] = useState({
        SN: '',
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rowTotal, setRowTotal] = useState(0);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [showAddOrModify, setShowAddOrModify] = useState(false);
    const [modifyRowIndex, setModifyRowIndex] = useState(null);
    const [infoForAddOrModify, setInfoForAddOrModify] = useState({});
    const [scrollY, setScrollY] = useState("");
    const [forceRefresh, setForceRefresh] = useState(0);


    const tip = "[InverterWithAgilePriceList]"

    function getTableScroll() {
        var th=  document.querySelectorAll("#table-inverter-with-agile-price-list .ant-table-thead")[0];
        let tHeaderBottom = 0
        if (th) {
            tHeaderBottom = th.getBoundingClientRect().top
        }
        let height = `calc(100vh - ${tHeaderBottom + 110}px)`
        return height
    }

    useEffect(() => {
        const scrollY = getTableScroll();
        setScrollY(scrollY);
        var tb =  document.querySelectorAll("#table-inverter-with-agile-price-list .ant-table-body")[0];
        tb.style.height = scrollY;
    }, [])

    useEffect(() => {
        let active = true;

        (async () => {
            setLoading(true);
            
            
            let resp = await http.post("inverter-v2/inverters-with-agile-price/list", { 
                PageNo: pageNo,
                PageSize: pageSize,
                ...params,
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                console.log(tip, e);
                return null;
            });

            if (! active) {
                return;
            }
            
            if (resp === null || resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load data error")});
                
                setRowTotal(0)
                setRows([]);
        
                return;
            }

            setRowTotal(resp.data.RowTotal);
            setRows( resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, params, forceRefresh]);

    const handleSearch = (v, e) => {
        setSelectedKeys([]);
        setPageNo(0);
        setParams({
            SN: v || "",
        });
        setForceRefresh(forceRefresh+1);
    }

    const renderAction = (v, r, idx) => {
        return (<Dropdown overlay={<Menu>
            <Menu.Item icon={<EditOutlined />} onClick={()=>{handleModify(idx)}}>{t("Modify")}</Menu.Item>
            <Menu.Item icon={<SwitcherOutlined />} onClick={()=>{handleEnabled(idx)}}>{r.Enabled ? t("Disable") : t("Enable")}</Menu.Item>
            <Menu.Item icon={<DeleteOutlined />} onClick={()=>{handleDelete(r.InverterSN, idx)}}>{t("Delete")}</Menu.Item>
        </Menu>}>
            <a onClick={(e) => e.preventDefault()}>
                <Space>
                    {t("Action")}
                    <DownOutlined />
                </Space>
            </a>
        </Dropdown>)
    }

    const handleAdd = () => {
        setInfoForAddOrModify({
            isNew: true, 
        });
        setShowAddOrModify(true);
    }

    const handleModify = (rowIndex) => {
        setInfoForAddOrModify({...rows[rowIndex]});
        setModifyRowIndex(rowIndex);
        setShowAddOrModify(true);
    }

    const handleEnabled = (rowIndex) => {
        var row = rows[rowIndex];
        if (!row) {
            return;
        }

        var enabled = row.Enabled ? 1 : 0;
        if (enabled === 1) {
            enabled = 0;
        } else {
            enabled = 1;
        }

        http.postJSON("inverter-v2/inverters-with-agile-price/enable-or-disable/do", {InverterSN: rows[rowIndex].InverterSN, Enabled: enabled}).then(async (r) => {
            return await r.json();
        }).then((resp) => {
            if (resp.code !== 200) {
                setTip({open: true, severity: 'error', msg: t("enable or disable error")});
                return;
            }

            row.Enabled = enabled;
            setRows([...rows]);

            setTip({open: true, severity: 'success', msg: t("enable or disable successfully")})
        }).catch((e) => {
            console.log(tip, e);
            setTip({open: true, severity: 'error', msg: t("enable or disable error")});
        });
    }

    const handleDelete = (InverterSN, idx) => {
        Modal.confirm({
            title: t('Do you Want to delete this item?'),
            icon: <ExclamationCircleOutlined />,
            content: InverterSN,
            onOk: () => {
                http.post("inverter-v2/inverters-with-agile-price/delete", {InverterSNs: InverterSN}).then(async(r) => {
                    return await r.json();
                }).then((resp) => {
                    if (resp.code !== 200) {
                        setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("delete error")});
                        return;
                    }

                    setTip({open: true, severity: 'success', msg: t('delete success')});

                    setRows([...rows.slice(0,idx), ...rows.slice(idx+1)]);
                    setRowTotal(rowTotal-1);
                    selectedKeys.every((v,i) => {
                        if (v === InverterSN) {
                            setSelectedKeys([...selectedKeys.slice(0,i), ...selectedKeys.slice(i+1)]);
                            return false;
                        }
        
                        return true;
                    })
                }).catch((e) => {
                    console.log(tip, e);
                    setTip({open:true, severity:"error", msg: t("delete error")});
                });
    
                
               
            },
            onCancel() {
                //
            },
        });
    }

    const handleDeleteAllOfSelected = async () => {
        if (selectedKeys.length < 1) {
            return;
        }

        let ns = [];
        selectedKeys.forEach((InverterSN) => {
            rows.every((r) => {
                if (InverterSN === r.InverterSN) {
                    ns.push(<label>{r.InverterSN}</label>);
                    return false;
                }

                return true;
            });
        })
        if (ns.length > 10) {
            ns = ns.slice(0, 10);
            ns.push(<lable>...</lable>);
        }

        Modal.confirm({
            title: t('Do you Want to delete these items?'),
            icon: <ExclamationCircleOutlined />,
            content: (<div style={{display:'flex', flexDirection:'column'}}>{ns}</div>),
            onOk: () => {
                http.post("inverter-v2/inverters-with-agile-price/delete", {InverterSNs: selectedKeys.join(",")}).then(async(r) => {
                    return await r.json();
                }).then((resp) => {
                    if (resp.code !== 200) {
                        setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("delete error")});
                        return;
                    }

                    setTip({open: true, severity: 'success', msg: t('delete success')});

                    let rs = [];
                    rows.forEach((v, i) => {
                        const InverterSN = v.InverterSN;
                        let ok = false;
                        selectedKeys.every((InverterSN2) => {
                            if (InverterSN === InverterSN2) {
                                ok = true;
                                return false;
                            }
        
                            return true;
                        });
                        if (!ok) {
                            rs.push(v);
                        } 
                    });
                    setRows(rs);
                    setRowTotal(rowTotal - selectedKeys.length);
                    setSelectedKeys([]);
                }).catch((e) => {
                    console.log(tip, e);
                    return null;
                });
    
                
                
            },
            onCancel() {
                //
            },
        });
    }

    const handleSelect = (selectedRowKeys, selectedRows) => {
        setSelectedKeys([...selectedRowKeys]);

        if (selectedRows.length === 1) {
            onInverterSelect(selectedRowKeys[0]);
        } else {
            onInverterSelect(null);
        }
    }

    const handleRowClassName = (record, index) => {
        return record.Enabled ? "" : "disabled";
    }

    const handleAddOrModifyOK = async (values) => {
        if (! values) {
            return;
        }

        // Fetch group_id from Octopus Energy API
        const fetchGroupId = async (postcode) => {
            try {
                const response = await fetch(`https://api.octopus.energy/v1/industry/grid-supply-points/?postcode=${postcode}`);
                const data = await response.json();
                
                if (data.results && data.results.length > 0) {
                    return data.results[0].group_id;
                } else {
                    throw new Error('No group_id found for the given postcode');
                }
            } catch (error) {
                console.error('Error fetching group_id:', error);
                setTip({open: true, severity: 'error', msg: t("Failed to fetch group_id")});
                return null;
            }
        };

        // Get the group_id before proceeding
        const groupId = await fetchGroupId(values.PostCode);
        if (!groupId) {
            return; // Exit if we couldn't get the group_id
        }

        values.RegionCode = groupId;

        //get import tariff code
        let resp = await http.post("inverter-v2/octopus-tariffs-codes/get", {ProductCode: values.ImportOctopusProductCode, Direction: "IMPORT", RegionCode: groupId}).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            console.log(tip, e);
        });
        if (resp === null || resp.code !== 200) {
            setTip({open: true, severity: 'error', msg: t("get octopus product code error")});
            return;
        }
        values.ImportTariffsCode = resp.data[0].TariffsCode;

        //get export tariff code
        resp = await http.post("inverter-v2/octopus-tariffs-codes/get", {ProductCode: values.ExportOctopusProductCode, Direction: "EXPORT", RegionCode: groupId}).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            console.log(tip, e);
        });
        if (resp === null || resp.code !== 200) {
            setTip({open: true, severity: 'error', msg: t("get octopus product code error")});
            return;
        }
        values.ExportTariffsCode = resp.data[0].TariffsCode;

        values.Enabled = values.isNew ? 1 : (rows[modifyRowIndex].Enabled);

        http.postJSON("inverter-v2/inverters-with-agile-price/add-or-modify/do", values).then(async (r) => {
            return await r.json();
        }).then((resp) => {
            if (resp.code !== 200) {
                setTip({open: true, severity: 'error', msg: t("add or modify error")});
                return;
            }

            setShowAddOrModify(false);

            if (values.isNew) {
                document.getElementsByClassName("ant-table-body")[0].scrollTo(0, 0);
                var x  = {...values }
                delete x.isNew;
                setSelectedKeys([x.InverterSN]);
                setRows([x, ...rows]);
                setRowTotal(rowTotal+1);
            } else {
                var row = {...rows[modifyRowIndex], ...values}
                setRows([...rows.slice(0, modifyRowIndex), row, ...rows.slice(modifyRowIndex+1)]);
            }

            setTip({open: true, severity: 'success', msg: t("add or modify successfully")})
        }).catch((e) => {
            console.log(tip, e);
            setTip({open: true, severity: 'error', msg: t("add or modify error")});
        });
    }


    const items = [{
        title: "",
        width: 70,
        fixed: 'left',
        render: (v, r, idx) => {
            return (pageNo * pageSize + idx + 1);
        }
    }, {
        title: t('SN'),
        dataIndex: 'InverterSN',
        width: 180,
        fixed: 'left',
    }, {
        title: t('PostCode'),
        dataIndex: 'PostCode',
        width: 80,
    }, {
        title: t('Weekday Type'),
        dataIndex: 'PointOrPriceWeekDay',
        width: 110,
    }, {
        title: t('Weekend Type'),
        dataIndex: 'PointOrPriceWeekEnd',
        width: 110,
    }, {
        title: t('Action'),
        key: 'Action',
        width: 90,
        render: renderAction,
    }]

    return (
        <div id="table-inverter-with-agile-price-list" style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            // padding: 8,
            height: '100%',
        }}>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingBottom: 8,
            }}>
                <div style={{
                    flex: "0 0 300px",
                    maxWidth: 400,
                }}>
                    <Input.Search style={{width: 250}} placeholder={t("Enter Inverter SN")} onSearch={handleSearch} enterButton />
                </div>
                
                <div style={{
                    flex: '1 1 auto',
                    display: "flex",
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Button onClick={handleAdd} type="primary"  icon={<PlusOutlined /> } shape="circle" size="middle" />
                    <Button onClick={handleDeleteAllOfSelected} disabled={selectedKeys.length===0} type="primary" shape="circle" icon={<DeleteOutlined  />} size="middle" style={{marginLeft: 5}}/>

                </div>
            </div>
            <div style={{
                flex:"1 1 1px",
                position: "relative",
            }}>
                <div style={{position: "absolute", height: '100%', width: "100%", overflow: "hidden"}}>
                    <Table 
                        columns={items}
                        pagination={{
                            pageSizeOptions: [25,50,100],
                            current: pageNo+1,
                            pageSize: pageSize,
                            total: rowTotal,
                            showSizeChanger: true,
                            showTotal: (total) => {return t("Total {{total}}", {total})},
                            onShowSizeChange: (current, size) => {
                                setPageSize(size);
                            },
                            onChange: (page, pageSize) => {
                                setPageNo(page-1);                                
                            }
                        }}
                        tableLayout="fixed"
                        bordered={true}
                        size="middle"
                        loading={loading}
                        rowKey="InverterSN"
                        dataSource={rows}
                        scroll={{ y: scrollY }}
                        rowClassName={handleRowClassName}
                        rowSelection={{
                            selectedRowKeys: selectedKeys,
                            onChange: handleSelect,
                            selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE]
                        }}
                        onRow={(record, index) => {
                            return {
                                onClick: (e) => {
                                    handleSelect([record.InverterSN], [record]);
                                },
                            };
                        }}
                    />
                </div>
            </div>
            <InverterWithAgilePriceAddOrModify open={showAddOrModify} onOk={handleAddOrModifyOK} onCancel={()=>setShowAddOrModify(false)} info={infoForAddOrModify}/>
        </div>
    );
}

export default InverterWithAgilePriceList;